import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

type BadRequestPopupProps = {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
};

export default function BadRequestPopup({
  isOpen,
  onClose,
  message = "Your prompt is not relevant to route planning. Please enter a valid route request.",
}: BadRequestPopupProps) {

  return (
    <Dialog open={isOpen} onClose={onClose} aria-labelledby="usage-limit-dialog-title" maxWidth="xs" fullWidth>
      <DialogTitle id="usage-limit-dialog-title">Bad Prompt</DialogTitle>
      <DialogContent>
        <Typography variant="body1" color="textSecondary">
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button style={{borderColor:'black', color:'black'}} variant="outlined" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
